module.exports = __webpack_public_path__ + "img/hsa-fsa-eligible-badge.12890d1d.png";